import UserList from '../../../base/pages/userlist';

const userList: UserList = {
  header: 'Seznam uživatelů',
  remove: 'Odebrat'
};

export default userList;
